import type { CustomerStore, EnsureOptions } from './interfaces'

import { _setCustomer } from './set-customer'
import { _fetchCustomer } from '../../api/fetch-customer'

export const actions = {
  _setCustomer (this: CustomerStore, customer: CustomerStore['customer']): void {
    return _setCustomer(this, customer)
  },

  async ensure (this: CustomerStore, options: EnsureOptions = {}): Promise<CustomerStore['customer']> {
    if (!options.force && this.customer) {
      return this.customer
    }

    if (this.customer && options.background) {
      void _fetchCustomer(this, true)

      return this.customer
    }

    return await _fetchCustomer(this, false)
  },

  async refreshNow (this: CustomerStore): Promise<CustomerStore['customer']> {
    return await _fetchCustomer(this, false)
  },

  clear (this: CustomerStore): void {
    _setCustomer(this, null)
  },

  setClarityReady (this: CustomerStore, payload: CustomerStore['clarityReady']): void {
    this.clarityReady = payload
  },
}
